export default [
    {
        path: '/emcadmin/customers',
        name: 'emcadmin-customers',
        component: () => import ('./views/CustomerIndex'),
        meta: {
            title: 'Clientes',
            icon: 'mdi-card-account-details-outline',
            breadcrumbs: [
                { text: 'Lista de clientes', disabled: true }
            ]
        }
    },
]
